<ul>
	<li [hasPermission]="'publicationconfig'" routerLinkActive="active"><a [routerLink]="['/publication/config/settings']"><i class="fa fa-cog"></i>{{ 'SETTINGS' | translate }}</a></li>

	<li [hasPermission]="'publicationconfig'" [ngClass]="{'active': activeLink.includes('custom-field')}"><a [routerLink]="['/publication/custom-fields/mediaclip']"><i class="fa fa-pencil-square"></i>{{ 'CUSTOM_FIELDS' | translate }}</a></li>
	
	<li [ngClass]="{'active': activeLink === 'usage'}"><a [routerLink]="['/publication/usage']"><i class="fa fa-bar-chart"></i>{{ 'USAGE' | translate }}</a></li>

	<li [hasPermission]="'usermanagement'" [ngClass]="{'active': activeLink === 'users'}"><a [routerLink]="['/publication/users']"><i class="fa fa-users"></i>{{ 'USERS' | translate }}</a></li>

	<li [hasPermission]="'apikeys'" [ngClass]="{'active': activeLink === 'api-keys'}"><a [routerLink]="['/publication/api-keys']"><i class="fa fa-key"></i>{{ 'API_KEYS' | translate }}</a></li>

	<li [ngClass]="{'active': activeLink === 'upload-credentials'}"><a [routerLink]="['/publication/upload-credentials']"><i class="fa fa-shield-keyhole"></i>{{ 'UPLOAD_CREDENTIALS' | translate }}</a></li>
</ul>
